// @flow

import React from 'react';

import { SelectField } from '@zapier/common-components';
import {
  type PaymentSourceMethod,
  type SupportedPaymentMethod,
  paymentSourceMethods,
} from '@zapier/payment/src/types';

type Props = {
  currentMethod?: PaymentSourceMethod,
  onChange: (method: PaymentSourceMethod) => void,
  supportedMethods: Array<SupportedPaymentMethod>,
};

const methodItems = {
  [paymentSourceMethods.card]: {
    label: 'Debit or Credit Card',
    value: paymentSourceMethods.card,
  },
  [paymentSourceMethods.paypal]: {
    label: 'PayPal',
    value: paymentSourceMethods.paypal,
  },
  [paymentSourceMethods.bank]: {
    label: 'Bank Transfer (US Only)',
    value: paymentSourceMethods.bank,
  },
};

const PaymentMethodSelect = ({
  currentMethod,
  onChange,
  supportedMethods = [],
}: Props) => {
  return (
    <SelectField
      items={supportedMethods
        .map(m => methodItems[m.type])
        .filter(m => m.value !== currentMethod)}
      menuAriaLabel="List of supported payment methods"
      onChange={item => onChange(item.value)}
      placeholder={`${currentMethod ? 'Switch' : 'Add'} Payment Method`}
    />
  );
};

export default PaymentMethodSelect;
